import UnitHandler from '@luketclancy/otterly/unit_handler'

export default class extends UnitHandler {
}